<template>
    <main class="main" id="main">
        <div class="top_line">
            <div class="container">
                <h1>Личный кабинет - Мои данные</h1>
            </div>
        </div>

        <!----------Section LK------------->

        <section class="section s-lk">

            <div class="container">

                <div class="lk_box">

                    <navigate></navigate>
                    <div class="account_box">
                        <h1>Персональная информация</h1>
                        <div class="personal-info_box">
                            <div class="profile_info">
                                <div class="info_row">
                                    <span>Имя</span>
                                    <input type="text" placeholder="Введите текст" v-model="user.name">
                                </div>

                                <div class="info_row">
                                    <span>Фамилия</span>
                                    <input type="text" placeholder="Введите текст" v-model="user.surname">
                                </div>

                                <div class="info_row">
                                    <span>Пол</span>
                                    <select class="select_info select_sexs" name="amount" v-model="sexs">
                                        <option value="1">Мужской</option>
                                        <option value="0">Женский</option>
                                    </select>
                                </div>

                                <div class="info_row">
                                    <span>Город</span>
                                    <select class="select select_city select_info" name="city" v-model="citys">
                                        <option v-if="user.city" :value="(user.city).toString()">{{user.city_name}}</option>
                                    </select>
                                </div>

                                <div class="info_row">
                                    <span>Дата рождения</span>
                                    <input type="date" placeholder="__ __ _____" v-model="user.birthday">
                                </div>

                                <div class="info_row">
                                    <span>Тел. номер</span>
                                    <input type="text" placeholder="+7(__)___ __ __" v-model="user.phone" data-inputmask="'mask': '+9(999)999-99-99'">
                                </div>

                                <div class="info_row">
                                    <span>Почта</span>
                                    <input type="text" placeholder="email "  v-model="user.email">
                                </div>

                                <div class="info_row">
                                    <span>Адрес</span>
                                    <input type="text" placeholder="Введите текст" v-model="user.address">
                                </div>

                                <div class="info_row">
                                    <span>Система для оплаты</span>
                                    <select class="select_info select_payType" name="amount" v-model="user.payType">
                                        <option value="">Выберите</option>
                                        <option value="visa">Visa</option>
                                        <option value="mastercard">Mastercard</option>
                                        <option value="yandex">Yandex</option>
                                    </select>
                                </div>

                                <div class="info_row">
                                    <span>Номер счета</span>
                                    <input type="text" placeholder="Введите номер" v-model="user.pay">
                                </div>
                                <button class="menu_item_btn" @click="saveProfile">СОХРАНИТЬ</button>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </section>

    </main>
</template>

<script>
import Inputmask from 'inputmask'
import navigate from '@/pages/lk/client/navigate'
import axios from '@/router/http'
import 'select2/dist/css/select2.min.css'
import 'select2'
export default {
  name: 'profile',
  props: ['city', 'auth', 'basket', 'geo', 'user'],
  data () {
    return {
      pay: 'bonus',
      sexs: '',
      citys: ''
    }
  },
  components: {navigate},
  created () {
    if (this.auth.uid) this.initAjax()
    else {
      let interval = setInterval(() => {
        if (this.auth.uid) {
          clearInterval(interval)
          this.initAjax()
        }
      }, 100)
    }
  },
  watch: {
    'sexs' (val) {
      $('.select_sexs').val(val).trigger('change.select2')
    },
    'citys' (val) {
      $('.select_city').val(val).trigger('change.select2')
    },
    user: {
      handler (newVal, oldVal) {
        this.sexs = this.user.sexs
        this.citys = this.user.city.toString()
      },
      deep: true
    }
  },
  methods: {
    initAjax () {
      Inputmask().remove(document.getElementById('input'))
      setTimeout(() => { Inputmask().mask(document.querySelectorAll('input')) }, 500)
      let self = this
      $('.select_sexs').select2({
        width: '100%'
      }).val(this.sexs).trigger('change.select2').on('select2:select', function () {
        self.sexs = $(this).val()
      })
      $('.select_payType').select2({
        width: '100%'
      }).val(this.user.payType).trigger('change.select2').on('select2:select', function () {
        self.user.payType = $(this).val()
      })
      $('.select_city').select2({
        width: '100%',
        ajax: {
          url: 'https://lk.when-hungry.com/site/search-city',
          data: (params) => {
            params.id = this.city.country_id
            params.q = params.term
            params.all = 0
            params.country = 1
            params.comm = 1
            return params
          },
          dataType: 'json',
          processResults: function (data) {
            return {
              results: $.map(data, function (key, item) {
                return {
                  text: key,
                  id: item
                }
              })
            }
          }
        }
      }).val(this.user.city_id).trigger('change.select2').on('select2:select', function () {
        self.citys = $(this).val()
      })
      this.sexs = this.user.sexs
      this.citys = this.user.city.toString()
    },
    saveProfile () {
      var formData = new FormData()
      formData.append('name', this.user.name)
      formData.append('surname', this.user.surname)
      formData.append('sex', this.sexs)
      formData.append('city_id', this.citys)
      formData.append('birthday', this.user.birthday)
      formData.append('email', this.user.email)
      formData.append('phone', this.user.phone)
      formData.append('address', this.user.address)
      formData.append('pay', this.user.pay)
      formData.append('payType', this.user.payType)
      formData.append('uid', this.auth.uid)
      axios.post('https://lk.when-hungry.com/mobile/put-mobile',
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }
      )
      setTimeout(() => { alert('Изменения успешно сохранены') }, 100)
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/lk/client/profile.vue